import {
  Bell,
  ClipboardCheck,
  FileCheck2,
  FolderSync,
  LineChart,
  ShieldCheck,
  Users,
  Workflow,
} from "lucide-react";
import { WHATSAPP_CFO } from "./cfoFraccionalData";

export const productosProximamente = {
  "gestion-aportes": {
    slug: "gestion-aportes",
    eyebrow: "Empresas · Beneficios",
    titulo: "Gestión de aportes",
    subtitulo:
      "Centralice cotizaciones pensionales, cumplimiento normativo y seguimiento de aportes corporativos en una sola plataforma.",
    descripcion:
      "Estamos construyendo una solución fintech para que su empresa administre aportes a pensión con trazabilidad, alertas automáticas y reportes listos para nómina — sin fricción operativa.",
    progreso: 45,
    faseActual: "Desarrollo de módulos core",
    navItems: [
      { label: "Visión", targetId: "vision" },
      { label: "Funcionalidades", targetId: "funcionalidades" },
      { label: "Roadmap", targetId: "roadmap" },
      { label: "Contacto", targetId: "contacto" },
    ],
    highlights: [
      { valor: "100%", etiqueta: "Digital", detalle: "Sin papeles ni reprocesos manuales" },
      { valor: "24/7", etiqueta: "Monitoreo", detalle: "Alertas de vencimientos y novedades" },
      { valor: "1", etiqueta: "Panel único", detalle: "Visibilidad para RRHH y finanzas" },
    ],
    funcionalidades: [
      {
        icon: LineChart,
        titulo: "Cotización inteligente",
        texto: "Simule y compare escenarios de aportes pensionales según plantilla, salarios y régimen aplicable.",
      },
      {
        icon: ShieldCheck,
        titulo: "Cumplimiento normativo",
        texto: "Validaciones automáticas para reducir riesgos de incumplimiento ante entidades de control.",
      },
      {
        icon: Users,
        titulo: "Gestión por colaborador",
        texto: "Historial individual de aportes, novedades y documentación asociada a cada integrante del equipo.",
      },
      {
        icon: Bell,
        titulo: "Alertas proactivas",
        texto: "Notificaciones de fechas límite, inconsistencias de nómina y cambios regulatorios relevantes.",
      },
    ],
    roadmap: [
      { fase: "Investigación", estado: "completado", detalle: "Levantamiento con empresas y validación de flujos reales." },
      { fase: "Diseño UX/UI", estado: "completado", detalle: "Prototipos de panel corporativo y experiencia de cotización." },
      { fase: "Desarrollo", estado: "activo", detalle: "Integración de reglas pensionales y motor de alertas." },
      { fase: "Piloto empresarial", estado: "pendiente", detalle: "Pruebas controladas con empresas aliadas de MEU." },
      { fase: "Lanzamiento", estado: "pendiente", detalle: "Disponibilidad general para clientes Empresas." },
    ],
    whatsapp: `${WHATSAPP_CFO.split("?")[0]}?text=${encodeURIComponent(
      "Hola, me interesa conocer más sobre Gestión de aportes para empresas cuando esté disponible."
    )}`,
    whatsappLabel: "Quiero ser contactado",
  },
  "tramites-digitales": {
    slug: "tramites-digitales",
    eyebrow: "Empresas · Operaciones",
    titulo: "Trámites digitales",
    subtitulo:
      "Digitalice solicitudes, documentación y seguimiento de trámites financieros corporativos desde un entorno seguro.",
    descripcion:
      "Pronto podrá gestionar trámites empresariales con trazabilidad en tiempo real, firma digital y un historial centralizado — diseñado para equipos financieros que necesitan velocidad con control.",
    progreso: 35,
    faseActual: "Arquitectura y seguridad",
    navItems: [
      { label: "Visión", targetId: "vision" },
      { label: "Funcionalidades", targetId: "funcionalidades" },
      { label: "Roadmap", targetId: "roadmap" },
      { label: "Contacto", targetId: "contacto" },
    ],
    highlights: [
      { valor: "0", etiqueta: "Filas físicas", detalle: "Radicación 100% en línea" },
      { valor: "360°", etiqueta: "Trazabilidad", detalle: "Estado de cada trámite en un solo lugar" },
      { valor: "SSL", etiqueta: "Seguridad", detalle: "Protección de datos y documentos sensibles" },
    ],
    funcionalidades: [
      {
        icon: Workflow,
        titulo: "Flujos guiados",
        texto: "Formularios inteligentes que adaptan los pasos según el tipo de trámite y la documentación requerida.",
      },
      {
        icon: FileCheck2,
        titulo: "Validación documental",
        texto: "Verificación automática de formatos, vigencias y completitud antes de enviar la solicitud.",
      },
      {
        icon: FolderSync,
        titulo: "Historial centralizado",
        texto: "Repositorio corporativo con versiones, responsables y fechas de cada gestión realizada.",
      },
      {
        icon: ClipboardCheck,
        titulo: "Seguimiento en vivo",
        texto: "Panel de estados, tiempos estimados y notificaciones cuando un trámite avance o requiera acción.",
      },
    ],
    roadmap: [
      { fase: "Mapeo de trámites", estado: "completado", detalle: "Identificación de procesos prioritarios para empresas." },
      { fase: "Diseño de experiencia", estado: "completado", detalle: "Flujos digitales y panel de seguimiento." },
      { fase: "Infraestructura segura", estado: "activo", detalle: "Capas de autenticación, cifrado y auditoría." },
      { fase: "Integraciones", estado: "pendiente", detalle: "Conexión con proveedores y entidades aliadas." },
      { fase: "Lanzamiento", estado: "pendiente", detalle: "Disponibilidad progresiva por módulo de trámite." },
    ],
    whatsapp: `${WHATSAPP_CFO.split("?")[0]}?text=${encodeURIComponent(
      "Hola, me interesa conocer más sobre Trámites digitales para empresas cuando esté disponible."
    )}`,
    whatsappLabel: "Quiero ser contactado",
  },
};

export const getProductoProximamente = (slug) => productosProximamente[slug] ?? null;
